/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Receive response.
 * @export
 * @interface TokenRequestRequest
 */
export interface TokenRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof TokenRequestRequest
     */
    deviceId: string;
    /**
     * 
     * @type {string}
     * @memberof TokenRequestRequest
     */
    assertion: string;
}

/**
 * Check if a given object implements the TokenRequestRequest interface.
 */
export function instanceOfTokenRequestRequest(value: object): value is TokenRequestRequest {
    if ((!('deviceId' in (value as Record<string, any>)) && !('device_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['deviceId'] === undefined && (value as Record<string, any>)['device_id'] === undefined)) return false;
    if (!('assertion' in value) || value['assertion'] === undefined) return false;
    return true;
}

export function TokenRequestRequestFromJSON(json: any): TokenRequestRequest {
    return TokenRequestRequestFromJSONTyped(json, false);
}

export function TokenRequestRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TokenRequestRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'deviceId': json['device_id'],
        'assertion': json['assertion'],
    };
}

export function TokenRequestRequestToJSON(json: any): TokenRequestRequest {
    return TokenRequestRequestToJSONTyped(json, false);
}

export function TokenRequestRequestToJSONTyped(value?: TokenRequestRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'device_id': value['deviceId'],
        'assertion': value['assertion'],
    };
}

